module.exports = __webpack_public_path__ + "static/media/Green-Forest.d53029cf.jpg";